export default __webpack_public_path__ + "static/media/t6.244f39e2.png";